<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="resources-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for checkbox and ID -->
          <div class="th col-id sticky-col layout-row layout-align-start-center gap-5">
            <span class="margin-left-5" translate>Resource</span>
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          @if (settings?.columns?.vehicleType) {
            <div class="th col-vehicle" translate>
              Vehicle Type
              <app-table-column-insert-button column="vehicleType"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.logisticVehicles) {
            <div class="th col-logistic-vehicle" translate>
              Logistic Vehicles
              <app-table-column-insert-button column="logisticVehicles"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.tags) {
            <div class="th col-tags" translate>
              Tags
              <app-table-column-insert-button column="tags"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.labels) {
            <div class="th col-labels" translate>
              Labels
              <app-table-column-insert-button column="labels"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.routesCount) {
            <div class="th col-routes-count" translate>
              Routes Count
              <app-table-column-insert-button column="routesCount"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.routeNames) {
            <div class="th col-route-names" translate>
              Route Names
              <app-table-column-insert-button column="routeNames"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.retrips) {
            <div class="th col-retrips" translate>
              Retrips
              <app-table-column-insert-button column="retrips"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.totalDuration) {
            <div class="th col-total-duration" translate>
              Total Duration
              <app-table-column-insert-button column="totalDuration"></app-table-column-insert-button>
            </div>
          }

          <!-- Load Columns -->
          @if (settings?.load?.weight) {
            <div class="th col-load col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.volume) {
            <div class="th col-load col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.packages) {
            <div class="th col-load col-load-packages" translate>
              Packages
              <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.spots) {
            <div class="th col-load col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.pallets) {
            <div class="th col-load col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.value) {
            <div class="th col-load col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }

          <!-- Capacity Columns -->
          @if (settings?.capacity?.weight) {
            <div class="th col-capacity col-capacity-weight" translate>
              Weight %
              <app-table-column-insert-button column="weight" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.volume) {
            <div class="th col-capacity col-capacity-volume" translate>
              Volume %
              <app-table-column-insert-button column="volume" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.pallets) {
            <div class="th col-capacity col-capacity-pallets" translate>
              Pallets %
              <app-table-column-insert-button column="pallets" group="capacity"></app-table-column-insert-button>
            </div>
          }

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!vm?.loading && !vm?.resources?.length" class="flex layout-row layout-align-center-center padding-20">
    <app-empty-state src="assets/images/empty_state/empty_state_drivers.png" text="No Resources Found"></app-empty-state>
  </div>

  <!-- Body: Handles vertical scrolling (starting under header) and horizontal scrolling -->
  <cdk-virtual-scroll-viewport *ngIf="vm.resources?.length"
                               class="body-container"
                               [itemSize]="31"
                               (scroll)="onBodyScroll($event)">

    <div class="table-inner-wrapper">
      <div class="resources-table-list-container">
        <ng-container>
          <app-resources-table-list-row *cdkVirtualFor="let resource of vm.resources; trackBy: trackById"
                                 [resource]="resource"
                                 [settings]="settings"
                                 [isSelected]="selectedKeys[resource.id]"
                                 [allPanelIds]="allPanelIds"
                                 [panelId]="panel.id"
                                 [isSummaryRow]="false"
                                 (onToggleSelection)="onToggleSelection($event.id, $event.isSelected)"
                                 (onDrop)="onDrop($event.resource, $event.event)"
                                 (onRowClick)="onRowClick($event.resource, $event.event)"
                                 (onRowDoubleClick)="onRowDoubleClick($event.resource, $event.event)">
    </app-resources-table-list-row>
        </ng-container>
      </div>
    </div>

  </cdk-virtual-scroll-viewport>

  <app-bringoz-linear-progress *ngIf="vm?.loading"></app-bringoz-linear-progress>
</div>
